'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isSymbol = {exports: {}};

exports.isSymbol = isSymbol;
